import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 48px;
`;

const SectionTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 30px;
  margin-top: 20px;
  color: var(--text-color);
`;

const TermsContent = styled.div`
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 120px;
  
  h2 {
    font-size: 1.8rem;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 1.4rem;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 20px;
  }
  
  ul {
    margin-bottom: 20px;
    padding-left: 20px;
    list-style-type: disc;
  }
  
  li {
    margin-bottom: 10px;
  }
`;

const TermsPage = () => {
    return (
        <PageContainer>
            <Container>
                <SectionTitle>Terms of Service</SectionTitle>

                <TermsContent>
                    <p>Effective Date: [Insert Date]</p>

                    <p>These Terms and Conditions ("Terms") govern your use of the website https://interstellarmap.com and the services provided by Interstellar Map ("we," "us," or "our"). By using our site and placing an order, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use our services.
                    </p>

                    <h2>1. Company Details</h2>
                    <ul>
                        <li>Company Legal Name: [To be updated - TBD]</li>
                        <li>Company Registration Number: [TBD]</li>
                        <li>Registered Address: [TBD]</li>
                        <li>Jurisdiction: United Kingdom</li>
                    </ul>

                    <h2>2. Our Service</h2>
                    <p>
                    We create personalized star maps showing the exact alignment of celestial objects as seen from a chosen location and date. Customers may customize the design and receive either a digital download or a printed product shipped to their address.
                    </p>

                    <p>All star maps are based on scientific data, including the Hipparcos Catalog and IAU standards.
                    </p>

                    <h2>3. Order Process</h2>
                    <p>To place an order:</p>

                    <ul>
                        <li>Choose your design and customization options</li>
                        <li>Provide accurate location, date, and time information</li>
                        <li>Enter billing and shipping details</li>
                        <li>Complete payment</li>
                    </ul>

                    <p>You are responsible for ensuring all information submitted is accurate. We are not liable for errors resulting from incorrect input.
                    </p>                    

                    <h2>4. Pricing and Payment</h2>
                    <p>
                    Prices are displayed in the applicable currency at checkout and include taxes where required. Payments are processed securely through third-party providers in compliance with PSD2 and SCA standards.
                    </p>
                </TermsContent>
            </Container>
        </PageContainer>
    );
};

export default TermsPage; 